import { Injectable } from '@angular/core';
import { EntityState, EntityStore, getEntityType, StoreConfig } from '@datorama/akita';

import { User } from '@shared/services/gql.service';
import { RequireSome } from '@shared/utils/utils';

export type TrialUserState = EntityState<
  Omit<RequireSome<Partial<User>, 'sub'>, 'organization' | 'permissions'> & {
    organization: {
      id: string;
      name: string;
    };
    permissions: { [k: string]: 'E' | 'U' };
  },
  string
>;

export type UserModel = getEntityType<TrialUserState>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ idKey: 'sub', name: 'trial-user' })
export class TrialUserStore extends EntityStore<TrialUserState> {
  constructor() {
    super({});
  }
}
